import { render, staticRenderFns } from "./EditImages.vue?vue&type=template&id=1b87ccec&"
import script from "./EditImages.vue?vue&type=script&lang=ts&"
export * from "./EditImages.vue?vue&type=script&lang=ts&"
import style0 from "./EditImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports